import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Site, SiteBasicDTO } from '../bo/site';
import { SiteFeatures } from '../bo/siteFeatures';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SiteCost } from '../bo/SiteCost';
import { ProductCost } from '../bo/products/product-cost';

export interface Co2CostRequest {
  productId: number;
  siteId: number;
  warehouseId: number;
}

export interface Co2CostResponse extends Co2CostRequest {
  co2CostId: number;
  co2Cost: number;
}

@Injectable({
  providedIn: 'root'
})
export class SitesService {
  private Sites: Site[] = [];

  constructor(private readonly httpService: HttpService) { }

  public getAllSites() {
    if (this.Sites.length > 0) {
      return new Observable(observer => {
        observer.next(this.Sites);
        observer.complete();
      });
    } else {
      return this.httpService.get<Site[]>('sites').pipe(
        tap(sites => this.Sites = sites)
      );
    }
  }

  public getPreviewOrtho(siteId: number, orthoName: string): Observable<Blob> {
    return this.httpService.getBlob(`sites/${siteId}/map/preview?orthoName=${orthoName}`);
  }

  public async getEpsgProjString(epsg: number): Promise<string> {
    return await this.httpService.get<string>('Sites/proj4/' + epsg).toPromise();
  }

  public getAssignedSitesForUser(userId: string): Promise<SiteBasicDTO[]> {
    return this.httpService.get<SiteBasicDTO[]>(`users/${userId}/sites`).toPromise();
  }

  public updateSite(site: Site): Observable<Site> {
    return this.httpService.put<Site, Site>('Sites', site);
  }

  public getSiteCosts(siteId: number): Observable<SiteCost[]> {
    return this.httpService.get<SiteCost[]>(`Sites/${siteId}/costs`);
  }

  public updateSiteCost(siteId: number, siteCost: SiteCost[]): Observable<SiteCost[]> {
    return this.httpService.put<SiteCost[], SiteCost[]>(`sites/${siteId}/costs`, siteCost);
  }
  public getProductCosts(regionId: number, siteId: number): Observable<ProductCost[]> {
    return this.httpService.get<ProductCost[]>(`Products/products-costs/${regionId}?siteId=${siteId}`);
  }
  public updateProductCost(ProductCost: ProductCost): Observable<any> {
    return this.httpService.put<ProductCost, any>(`Products/cost`, ProductCost);
  }

  public getCo2CostsBySite(siteId: number): Observable<Co2CostResponse[]> {
    return this.httpService.get<Co2CostResponse[]>(`Sites/${siteId}/co2costs`);
  }

  public getSiteFeatures(siteId: number): Observable<SiteFeatures> {
    return this.httpService.get<SiteFeatures>(`sites/${siteId}/features`);
  }

  public updateSiteFeatures(siteId: number, features: SiteFeatures): Observable<SiteFeatures> {
    return this.httpService.put<SiteFeatures, SiteFeatures>(`sites/${siteId}/features`, features);
  }

  public createCo2Cost(co2Cost: Co2CostRequest): Observable<Co2CostResponse> {
    return this.httpService.post<Co2CostRequest, Co2CostResponse>(`Products/co2cost`, co2Cost);
  }

  public updateCo2Cost(co2CostId: number, co2Cost: Co2CostRequest): Observable<Co2CostResponse> {
    return this.httpService.put<Co2CostRequest, Co2CostResponse>(`Products/co2cost/${co2CostId}`, co2Cost);
  }

}
